<template>
	<div>
		<v-dialog persistent @click:outside="closeDialog()" scrollable :value="dialogVisible" max-width="800">

			<v-form ref="form" @submit.prevent="save">
				<v-card >
						<v-overlay
							v-if="isSaving"
							:value="true"
							absolute
							:dark="false"
							light
							color="white"
							opacity="0.8"

						>
							<div class="d-flex flex-column justify-content-center">
								<div class="text-muted text-center">
									<div v-if="saving.image">Przesyłanie zdjęcia...</div>
									<div v-else-if="saving.video">Przesyłanie filmu...</div>
									<div v-else-if="saving.attachments.length">Przesyłanie załączników...</div>
									<div v-else>Zapisywanie...</div>
									<v-progress-circular
										v-if="saving.post"
										indeterminate
										size="50"
										class="mt-3"
									></v-progress-circular>
									<v-progress-linear
										v-else
										color="accent"
										indeterminate
										width="150"
										class="mt-3"
									></v-progress-linear>
								</div>
							</div>
						</v-overlay>
						<v-card-title>
							{{ title }}
							<v-btn icon @click="closeDialog()" class="ml-auto">
								<v-icon>mdi-close</v-icon>
							</v-btn>
						</v-card-title>
						<v-card-text>
							<div class="d-flex flex-row align-items-center my-5">
								<avatar :user="user" />
								<div class="ml-2">
									<div class="small mb-0">{{ $vuetify.lang.t('$vuetify.views.wall.addNewPost.dialog.post.publishAs') }}</div>
									<div class="bold font-16">{{ user.name }}</div>
								</div>
							</div>
							<div class="mt-10">
								<div v-if="showSubject">
									<label for="new-post__subject" class="bold">Tytuł</label>
									<div class="d-flex flex-row">
										<v-text-field id="post__subject" v-model="fields.title" ref="subject" outlined elevation="0" dense counter="50" :rules="[rules.subject]"/>
									</div>
								</div>
								<!--
								<v-textarea
									ref="textarea"
									outlined
									elevation="0"
									:placeholder="$vuetify.lang.t('$vuetify.views.wall.addNewPost.startTyping')"
									v-model="fields.content.content"
									:rules="[rules.text]"
									hide-details
									auto-grow
									class="mt-3"
								></v-textarea>
								-->


								<content-editable-input
									@input="onInput"
									v-model="fields.content"
									:key="inputKey"
									emojis
									newLineOnEnter
									:error="validated && errors.content ? true : false"
									ref="content-editable-input"
									style="min-height: 80px"
									:placeholder="$vuetify.lang.t('$vuetify.views.wall.addNewPost.startTyping')"
									:class="[{ 'post-comment-add-input--dark' : dark }, 'post-comment-add-input d-flex flex-grow-1 font-14 rounded px-2']"
								/>
								<div class="d-flex">
									<div>
										<v-switch v-model="fields.isCommentsDisabled" :value="true" hide-details class="mt-2" label="Wyłącz komentowanie" />
									</div>
								</div>
							</div>
							<div :key="contentKey">
								<!-- IMAGE -->
								<div v-if="fields.type == 'image'" :key="'image-' + contentKey" class="mt-5">
									<div v-if="fields.image" class="mt-2">
										<div class="bold">Zdjęcie</div>
										<div class="relative">
											<div class="buttons">
												<v-btn v-if="fields.image.data"  @click="openChild('image')" class="icon-button px-2 mr-1"><v-icon>mdi-pencil</v-icon></v-btn>
												<v-btn v-if="fields.image.data && !edit" @click="removeImage()" class="icon-button px-2"><v-icon>mdi-delete</v-icon></v-btn>
											</div>
											<v-img v-if="fields.image.data" :src="fields.image.data" class="rounded"/>
										</div>
									</div>
									<div v-else class="rounded text-center py-5" :class="{'text-danger': errors.image}">
										<v-icon size="40" color="red" :class="{'text-danger': errors.image}">mdi-image-broken</v-icon>
										<div class="text-error mb-2 bold">Brak zdjęcia</div>
										<v-btn @click="openChild('image')" class="mt-3"><v-icon>mdi-plus</v-icon> Dodaj zdjęcie</v-btn>
									</div>

								</div>

								<!-- VIDEO -->
								<div v-if="fields.type == 'video'" class="content-wrap mt-5">
									<div class="mt-2">
										<div v-if="fields.video">
											<div class="bold">Video</div>
											<div class="relative video-placeholder rounded">
												<div class="buttons">
													<v-btn @click="openChild('video')" class="icon-button px-2 mr-1"><v-icon>mdi-pencil</v-icon></v-btn>
													<v-btn v-if="!edit" @click="removeVideo()" class="icon-button px-2"><v-icon>mdi-delete</v-icon></v-btn>
												</div>
												<v-icon size="50" color="white">$video</v-icon>
												{{  fields.video.name || fields.video.original_name }}
											</div>
										</div>
										<div v-else class="rounded text-center py-5" :class="{'text-danger': errors.video}">
											<v-icon size="40" color="red" :class="{'text-danger': errors.video}">mdi-image-broken</v-icon>
											<div class="text-error mb-2 bold">Brak video</div>
											<v-btn @click="openChild('video')" class="mt-3"><v-icon>mdi-plus</v-icon> Dodaj film</v-btn>
										</div>
									</div>
								</div>

								<!-- POLL -->
								<div v-if="fields.type == 'poll'" class="content-wrap mt-5">
									<div class="d-flex flex-row align-items-center">
										<div class="bold">Ankieta</div>
										<v-btn v-if="!edit" icon @click="removePoll()" class="ml-auto"><v-icon>mdi-delete</v-icon></v-btn>
									</div>
									<div v-if="fields.poll" class="border border-light">
										<div class="d-flex flex-wrap mb-3">
											<div class="bold dark d-flex align-items-center font-16" ><v-icon color="accent" class="mr-1">$chart-bar</v-icon> {{ fields.poll.question }}</div>
											<div v-if="(edit && !post.postable.total_users_answer_count) || (!edit)" class="ml-auto">
												<v-btn @click="openChild('poll')" text small><v-icon small>mdi-pencil</v-icon> Edytuj</v-btn>
											</div>
											<div v-else class="ml-auto text-muted">{{ $vuetify.lang.t('$vuetify.cannotEdit') }}</div>
										</div>
										<div class="mt-5">
											<div v-for="(answer, index) in fields.poll.answers" :key="index" class="mb-2 font-14 bold">
												<v-radio
													disabled
													:label="answer.answer"
												></v-radio>
											</div>
										</div>
										<div v-if="fields.poll.allowCustom" class="mt-3 text-muted"><v-icon>mdi-check</v-icon> Zgoda na własne odpowiedzi</div>
										<hr class="muted-light my-3"/>
										<div class="small">Czas trwania ankiety:  <span class="bold">{{ fields.poll.finishAt ? `Do ${pollFinishTime}` : "Bez ograniczeń" }}</span></div>
									</div>
								</div>

								<!-- ANNOUNCEMENT -->
								<div v-if="fields.type == 'announcement' && ((!groupId && isManager) || (groupId && isGroupAdmin))" class="content-wrap mt-5">
									<v-switch v-model="fields.announcement.pinned" :value="true" :label="$vuetify.lang.t('$vuetify.views.wall.addNewPost.dialog.announcement.pinned')"></v-switch>
									<div v-if="fields.announcement.pinned" class="my-2" :class="{'text-danger': errors.announcement}">
										<div class="bold">Ustaw datę automatycznego odpięcia wpisu</div>
										<date-time-picker @selected="announcementFinishTimeSelected" :date="fields.announcement.finishAt" empty-text="Wybierz datę" :error="errors.announcement ? true : false"  />
									</div>
								</div>

								<!-- ATTACHMENTS -->
								<div v-if="fields.type == 'attachment'" class="mt-5">
									<div class="bold">Załączniki</div>

									<div v-for="(item, index) in fields.attachments" :key="index" class="attachment-item">
										<v-icon>$file</v-icon>
										{{ item.name || item.original_name }} <v-btn @click="deleteAttachment(index)" class="ml-auto" icon><v-icon>mdi-delete</v-icon></v-btn>
									</div>
									<v-btn v-if="fields.attachments.length" elevation="0" @click="openChild('attachment')" color="secondary"><v-icon>mdi-plus</v-icon> Dodaj załącznik</v-btn>
								</div>

								<!-- KUDOS -->
								<div v-if="fields.type == 'kudos'" class="mt-5">
									<div class="bold">Pochwała</div>
									<div v-if="fields.kudos" class="kudos-container rounded">
										<div class="buttons">
											<v-btn @click="openChild('kudos')" class="icon-button px-2 mr-1"><v-icon>mdi-pencil</v-icon></v-btn>
											<v-btn @click="fields.kudos = {}, setType('post')" class="icon-button px-2"><v-icon>mdi-delete</v-icon></v-btn>
										</div>
										<div class="kudos-overlay"></div>
										<v-img :src="fields.kudos.image" class="rounded"/>

										<div class="txt">
											<div class="type">{{ fields.kudos.content }}</div>
											<div v-if="fields.kudos.user" class="username">{{ fields.kudos.user.name || fields.kudos.user.email }}</div>
										</div>
										<div class="kudos-overlay"></div>
									</div>
								</div>
							</div>
						</v-card-text>
						<v-card-actions class="justify-content-left custom-action py-5 flex-wrap px-6">
							<v-tooltip v-if="!edit || (edit && (type == 'post'))" top >
								<template v-slot:activator="{ on, attrs }">
									<v-btn v-bind="attrs" v-on="on" @click="setType('post')" :class="{'active': fields.type == 'post'}" class="icon-button px-3 mr-2 mb-2" elevation="0" height="40"><v-icon>$post</v-icon></v-btn>
								</template>
								<span>{{ $vuetify.lang.t('$vuetify.views.wall.addNewPost.dialog.post.tooltips.post') }}</span>
							</v-tooltip>
							<v-tooltip v-if="!edit || (edit && type == 'image')" top >
								<template v-slot:activator="{ on, attrs }">
									<v-btn v-bind="attrs" v-on="on" @click="openChild('image')" :class="{'active': fields.type == 'image'}" class="icon-button px-3 mr-2 mb-2" elevation="0" height="40"><v-icon>$photo</v-icon></v-btn>
								</template>
								<span>{{ $vuetify.lang.t('$vuetify.views.wall.addNewPost.dialog.post.tooltips.image') }}</span>
							</v-tooltip>
							<v-tooltip v-if="!edit || (edit && type == 'video')" top >
								<template v-slot:activator="{ on, attrs }">
									<v-btn v-bind="attrs" v-on="on" @click="openChild('video')" :class="{'active': fields.type == 'video'}" class="icon-button px-3 mr-2 mb-2" elevation="0" height="40"><v-icon>$video</v-icon></v-btn>
								</template>
								<span><span>{{ $vuetify.lang.t('$vuetify.views.wall.addNewPost.dialog.post.tooltips.video') }}</span></span>
							</v-tooltip>
							<v-tooltip v-if="!edit || (edit && type == 'poll')" top >
								<template v-slot:activator="{ on, attrs }">
									<v-btn v-bind="attrs" v-on="on" @click="openChild('poll')" :class="{'active': fields.type == 'poll'}" class="icon-button px-3 mr-2 mb-2" elevation="0" height="40"><v-icon>$chart-bar</v-icon></v-btn>
								</template>
								<span><span>{{ $vuetify.lang.t('$vuetify.views.wall.addNewPost.dialog.post.tooltips.poll') }}</span></span>
							</v-tooltip>
							<v-tooltip v-if="!edit || (edit && type == 'problem')" top >
								<template v-slot:activator="{ on, attrs }">
									<v-btn v-bind="attrs" v-on="on" @click="setType('problem')" :class="{'active': fields.type == 'problem'}" class="icon-button px-3 mr-2 mb-2" elevation="0" height="40"><v-icon>$help</v-icon></v-btn>
								</template>
								<span><span>{{ $vuetify.lang.t('$vuetify.views.wall.addNewPost.dialog.post.tooltips.problem') }}</span></span>
							</v-tooltip>
							<v-tooltip v-if="((!groupId && isManager) || (groupId && isGroupAdmin)) && (!edit || (edit && type == 'announcement'))" top >
								<template v-slot:activator="{ on, attrs }">
									<v-btn v-bind="attrs" v-on="on" @click="setType('announcement')" :class="{'active': fields.type == 'announcement'}" class="icon-button px-3 mr-2 mb-2" elevation="0" height="40"><v-icon>$announcement</v-icon></v-btn>
								</template>
								<span><span>{{ $vuetify.lang.t('$vuetify.views.wall.addNewPost.dialog.post.tooltips.announcement') }}</span></span>
							</v-tooltip>
							<v-tooltip v-if="!edit || (edit && type == 'attachment')" top >
								<template v-slot:activator="{ on, attrs }">
									<v-btn v-bind="attrs" v-on="on" @click="openChild('attachment')" :class="{'active': fields.type == 'attachment'}" class="icon-button px-3 mr-2 mb-2" elevation="0" height="40"><v-icon>$file-add</v-icon></v-btn>
								</template>
								<span><span>{{ $vuetify.lang.t('$vuetify.views.wall.addNewPost.dialog.post.tooltips.attachment') }}</span></span>
							</v-tooltip>
							<v-tooltip v-if="!edit || (edit && type == 'kudos')" top >
								<template v-slot:activator="{ on, attrs }">
									<v-btn v-bind="attrs" v-on="on" @click="openChild('kudos')" :class="{'active': fields.type == 'kudos'}" class="icon-button px-3 mr-2 mb-2" elevation="0" height="40"><v-icon>$carrot</v-icon></v-btn>
								</template>
								<span><span>{{ $vuetify.lang.t('$vuetify.views.wall.addNewPost.dialog.post.tooltips.praise') }}</span></span>
							</v-tooltip>
							<div class="ml-auto">
								<v-menu
									v-if="!edit"
									bottom
									offset-y
									width="200px"
									>
										<template v-slot:activator="{ on, attrs }">
											<v-btn
												v-bind="attrs"
												v-on="on"
												class="mr-2 mb-2 little-select"
												color="white"
												:disabled="!!groupId"
												style="border: none !important"
											>
												<v-icon class="mr-1">{{ fields.visibility == 'company' ? '$world' : 'mdi-account-outline' }}</v-icon> {{ getVisibility(fields.visibility).title }} <v-icon v-if="!groupId">mdi-chevron-down</v-icon>
											</v-btn>
										</template>
										<v-list>
											<v-list-item
												v-for="(item, index) in visibilities"
												:key="index"
												class="link"
												@click="setVisibility(item.name)"
											>
												<span style="width: 30px">
													<v-icon class="link">{{  item.icon }}</v-icon>
												</span> {{ item.title }}
											</v-list-item>
										</v-list>
								</v-menu>
								<v-btn
									@click="closeDialog()"
									height="40"
									color="light"
									elevation="0"
									class="mb-2 mr-2"
								>
									<span>{{ $vuetify.lang.t('$vuetify.cancel')  }}</span>
								</v-btn>
								<v-btn
									height="40"
									color="primary"
									elevation="0"
									type="submit"
									class="mb-2"
								>
									<span>{{ !edit ? $vuetify.lang.t('$vuetify.publish') : $vuetify.lang.t('$vuetify.save') }}</span>
								</v-btn>
							</div>
						</v-card-actions>
				</v-card>
			</v-form>
		</v-dialog>
		<attach-image-dialog ref="attachImage" @selected="setImage" @closed="child = false, dialog = true" :key="'image-' + contentKey"/>
		<attach-video-dialog ref="attachVideo" @selected="setVideo" @closed="child = false, dialog = true" :key="'video-' + contentKey"/>
		<attach-poll-dialog ref="attachPoll" @selected="setPoll" @closed="child = false, dialog = true" :key="'poll-' + contentKey" :edit="edit"/>
		<attach-attachments-dialog ref="attachAttachments" @selected="addAttachments" @closed="child = false, dialog = true" :key="'attachments-' + contentKey"/>
		<attach-kudos-dialog ref="attachKudos" @selected="setKudos" @closed="child = false, dialog = true" :key="'kudos-' + contentKey" :edit="edit"/>
		<delete-file-dialog v-if="edit && type == 'attachment'" ref="deleteFile" @deleted="attachmentDeleted" />
	</div>
</template>

<script>
import {mapGetters} from 'vuex';
import AttachImageDialog from '@/components/wall/dialogs/AttachImageDialog';
import AttachVideoDialog from '@/components/wall/dialogs/AttachVideoDialog';
import AttachPollDialog from '@/components/wall/dialogs/AttachPollDialog';
import DateTimePicker from '@/components/pickers/DateTimePicker';
import AttachAttachmentsDialog from '@/components/wall/dialogs/AttachAttachmentsDialog';
import AttachKudosDialog from '@/components/wall/dialogs/AttachKudosDialog';
import ContentEditableInput from '@/components/items/ContentEditableInput';
const DeleteFileDialog = import("@/components/wall/dialogs/DeleteFileDialog");
import Avatar from '@/components/Avatar';
import axios from 'axios'
export default {
	props: {
		groupId: {
			type: Number,
			required: false,
		},
		isGroupAdmin: {
			required: false,
			type: Boolean
		},
		edit: {
			type: Boolean,
			required: false,
			default: false
		},
		post: {
			type: Object,
			default: null
		},
		type: {
			type: String
		},
		shareUrl: {
			type: [String, Boolean],
			default: null
		},
		shareTitle: {
			type: [String, Boolean],
			default: null
		},
	},
	components: {
		AttachImageDialog,
		AttachVideoDialog,
		AttachPollDialog,
		DateTimePicker,
		AttachAttachmentsDialog,
		AttachKudosDialog,
		ContentEditableInput,
		Avatar,
		DeleteFileDialog: () => ({
			component: DeleteFileDialog,
		}),
	},
	data() {
		return {
			validated: false,
			child: false,
			saving: {
				image: false,
				video: false,
				attachments: [],
				post: false
			},
			inputKey: 0,
			contentKey: 0,
			dialog: false,
			fields: {
				content: {
					content: '',
					mentions: []
				},
				isCommentsDisabled: false,
				isPinned: false,
				type: 'post',
				text: null,
				visibility: 'company',
				visibilitable_id: null,
				image: null,
				video: null,
				poll: null,
				announcement: null,
				attachments: [],
				kudos: null,
				imageToken: null,
				videoToken: null,
				uploadedVideo: null,
				attachmentTokens: [],
				// the rest of types
			},
			selects: {
				visibility: [
					{
						name: 'company',
						title: this.$vuetify.lang.t('$vuetify.views.wall.visibilities.all'),
						icon: '$world'
					},
					{
						name: 'team',
						title: this.$vuetify.lang.t('$vuetify.views.wall.visibilities.team'),
						icon: 'mdi-account-multiple-outline'
					},
					{
						name: 'group',
						title: this.$vuetify.lang.t('$vuetify.views.wall.visibilities.group'),
						icon: 'mdi-account-multiple-outline'
					},
					{
						name: 'user',
						title: this.$vuetify.lang.t('$vuetify.views.wall.visibilities.private'),
						icon: 'mdi-lock-outline'
					},

				]
			},
			rules: {
				required: value => !!value || 'Pole wymagane.',
				subject: value => {
					if(this.showSubject && value) {
						return true
					}
					return 'Podaj tytuł'
				},
				text: value => {
					if(this.fields.type != 'image' && this.fields.type != 'video' && this.fields.type != 'poll') {
						if(value) {
							return true;
						}
						return 'Dodaj treść'
					}
					return true;
				}
			},
			errors: {}
		}
	},
	watch: {
		'fields.content': function(newVal) {
			if(this.fields.type == 'kudos') {
				if(newVal) {
					if((newVal.mention_users && !newVal.mention_users.length) || (newVal.mentions && !newVal.mentions.length)) {
						this.fields.kudos = null;
						this.setType('post');
					}
				}
				else {
					this.fields.kudos = null;
					this.setType('post');
				}


			}

		}
	},
	computed: {
		...mapGetters({
			user: 'auth/user',
			attachmentValidation: 'validation/attachments',
			uploadProgress: 'files/uploadProgress',
			kudosTypes: 'dictionaries/kudosTypes'
		}),
		attachmentsToUpload() {
			return this.fields.attachments.filter(x => !x.id);
		},
		dark: function () {
			return this.$vuetify.theme.dark
		},
		visibilities() {
			if(!this.groupId) {
				return this.selects.visibility.filter(x => x.name != 'group');
			}
			return this.selects.visibility.filter(x => x.name == 'group');

		},
		isSaving() {
			if(this.saving.post || this.saving.image || this.saving.video || this.saving.attachments.length) {
				return true;
			}
			return false;
		},

		finalModel() {
			let model = {
				visibilitable_type: (this.groupId) ? 'group' : this.fields.visibility,
				is_comments_disabled: this.fields.isCommentsDisabled ? true : false,
				mentions: [],
				content: ''
			};
			if(this.groupId) {
				model.visibilitable_id = this.groupId;
			}

			if(this.fields.content.content) {
				// Mentions
				model.content = this.fields.content.content;
				if(this.fields.content.mentions) {
					model.mention_user_ids  = this.fields.content.mentions.filter(x => !!x);
				}
			}
			else {
				model.content = '';
				model.mention_user_ids  = [];
			}
			if(this.fields.type == 'post') {
				// Post
			}
			else if(this.fields.type == 'image') {
				// Image
				if(!this.edit) {
					model.image_token = this.fields.imageToken;
				}
				else {
					if(this.post.image.url != this.fields.image.data) {
						model.image_token = this.fields.imageToken
					}
				}
			}
			else if(this.fields.type == 'video') {
				// Video
				if(!this.edit) {
					model.video_token = this.fields.videoToken;
				}
				else {
					// Edit
					if(this.fields.videoToken) {
						model.video_token = this.fields.videoToken;
					}
				}

			}
			else if(this.fields.type == 'attachment') {
				// Attachment
				model.attachment_tokens = this.fields.attachmentTokens;
			}
			else if(this.fields.type == 'poll') {
				// Poll
				model.poll = {
					question: this.fields.poll.question,
					is_allowed_custom_answers: this.fields.poll.allowCustom ? true : false,
					poll_answers: this.fields.poll.answers
				}
				if(this.fields.poll.finishAt) {
					model.ended_at = this.fields.poll.finishAt;
				}
			}
			else if(this.fields.type == 'kudos') {
				// Kudos TODO
				model.kudos = {
					for_user_id: this.fields.kudos.user.id,
					kudos_type_id: this.fields.kudos.typeId,
					content: this.fields.kudos.content
				}
			}
			else if(this.fields.type == 'announcement') {
				// Announcement
				if(this.fields.announcement) {
					model.is_announcement = true;
					model.is_pinned  = this.fields.announcement.pinned ? true : false;
					if(model.is_pinned) {
						model.ended_at = this.fields.announcement.finishAt;
					}

				}
			}
			else if(this.fields.type == 'problem') {
				// Problem TODO
				delete model.content;
				model.problem = {
				title: this.fields.title,
					description: this.fields.content.content
				}
			}
			else if(this.fields.type == 'kudos') {
				model.kudos = {
					for_user_id: this.fields.kudos.for_user_id,
					kudos_type_id: this.fields.kudos.typeId,
					content: this.fields.kudos.content // Todo
				}
			}

			return model;
		},
		pollFinishTime() {
			if(this.fields.poll && this.fields.poll.finishAt) {
				if(this.$moment(this.fields.poll.finishAt).format("HH:mm") != '00:00') {
					return this.$moment(this.fields.poll.finishAt).format("LLL");
				}
				return this.$moment(this.fields.poll.finishAt).format("LL");
			}
			return null;
		},
		title() {
			if(this.fields.type == 'problem') {
				if(!this.edit) {
					return this.$vuetify.lang.t('$vuetify.views.wall.problem.addProblem')
				}
				return this.$vuetify.lang.t('$vuetify.views.wall.problem.editProblem')
			}
			else if(this.fields.type == 'announcement') {
				if(!this.edit) {
					return this.$vuetify.lang.t('$vuetify.views.wall.addNewPost.dialog.announcement.header')
				}
				return this.$vuetify.lang.t('$vuetify.views.wall.announcement.editAnnouncement')

			}
			if(!this.edit) {
				return this.$vuetify.lang.t('$vuetify.views.wall.addNewPost.dialog.post.header')
			}
			return this.$vuetify.lang.t('$vuetify.views.wall.addNewPost.dialog.post.editHeader')

		},
		dialogVisible() {
			return this.dialog && !this.child;
		},
		showSubject() {
			if(this.fields.type == 'problem') {
				return true;
			}
			return false;
		},
		saveUrl() {
			if(this.fields.type == 'poll') {
				return 'posts/poll'
			}
			else if(this.fields.type == 'problem') {
				return 'posts/problem'
			}
			else if(this.fields.type == 'kudos') {
					return 'posts/kudos'
			}
			else {
				return 'posts'
			}
		},
		isManager() {
			if(this.user.role && this.user.role.name == 'manager') {
				return true;
			}
			else if(this.user.roles.is_manager) {
				return true;
			}
			return false;
		}
	},
	methods: {
		attachmentDeleted(file) {
			if(file && file.id) {
				const idx = this.fields.attachments.findIndex(x => x.id == file.id);
				if(idx) {
					this.fields.attachments.splice(idx, 1);
				}
				this.$store.dispatch('wall/setPostProperty', {
					id: this.post.id,
					updated_at: this.$moment().local(),
					attachments: this.fields.attachments.filter(x => x.id)
				});
			}
		},
		validate() {
			let valid = true;
			if(this.$refs.form) {
				valid = this.$refs.form.validate();
			}

			this.errors = {};

			if(this.fields.type != 'image' && this.fields.type != 'video' && this.fields.type != 'poll') {
				if(!this.fields.content.content) {
					this.validated = true;
					valid = false;
					this.errors.content = 'Uzupełnij treść'
				}
			}
			else {
				this.errors.content = false;
			}

			if(this.fields.type == 'image') {
				if(!this.fields.image) {
					valid = false;
					this.errors.image = 'Wybierz zdjęcie'
				}
			}
			else if(this.fields.type == 'video') {
				if(!this.fields.video) {
					valid = false;
					this.errors.video = 'Wybierz video'
				}
			}
			else if(this.fields.type == 'announcement') {
				if(!this.fields.announcement.finishAt) {
					valid = false;
					this.errors.announcement = 'Wybierz datę odpięcia wpisu'
				}
			}

			if(!valid) {
				this.$snackbar.error('Wypełnij wymagane pola');
			}

			return valid;
		},
		getKudos(typeId) {
			return this.kudosTypes.find(x => x.id == typeId);
		},
		deleteAttachment(index) {
			if(this.fields.attachments[index]) {
				if(!this.edit) {
					this.fields.attachments.splice(index, 1);
					this.$nextTick(() => {
						if(!this.fields.attachments.length) {
							this.setType('post');
						}
					})
				}
				else {
					if(this.fields.attachments[index].id) {
						this.$refs.deleteFile.showDialog(this.fields.attachments[index]);
					}
					else {
						this.fields.attachments.splice(index, 1);
					}
				}
			}


		},
		async uploadImage() {
			if(this.fields.image) {
				this.saving.image = true;
				const response = await this.$store.dispatch('files/uploadPhoto', {
					for: 'post_image',
					file: encodeURIComponent(this.fields.image.data)
				});
				if(response.success) {
					this.fields.imageToken = response.data.token;
					this.saving.image = false;
					return true;
				}
				else {
					this.saving.image = false;
					return false;
				}

			}
		},
		async uploadVideo() {
			if(this.fields.video) {
				this.saving.video = true;
				const response = await this.$store.dispatch('files/uploadVideo', {
					for: 'post_video',
					file: this.fields.video
				});
				if(response.success) {
					this.fields.uploadedVideo = response.data;
					this.fields.videoToken = response.data.token;
					this.saving.video = false;
					return true;
				}
				else {
					this.saving.video = false;
					return false;
				}

			}
		},
		async uploadAttachment(attachment) {
			if(attachment) {
				const idx = this.fields.attachments.length + 1;
				this.saving.attachments.push({
					idx: idx,
					attachment: attachment
				});
				const response = await this.$store.dispatch('files/uploadAttachment', {
					for: 'post_attachment',
					file: attachment
				});
				const i = this.fields.attachments.find(x => x.idx == idx);
				if(response.success) {
					this.fields.attachmentTokens.push(response.data.token);
					if(i) {
						this.saving.attachments.splice(i, 1);
					}
					return true;
				}
				else {
					this.saving.video = false;
					if(i) {
						this.saving.attachments.splice(i, 1);
					}
					return false;
				}
			}
		},
		async uploadAttachments() {
			let succeded = [];
			let failed = [];
			await Promise.all(this.attachmentsToUpload.map(async (attachment) => {
				const res = await this.uploadAttachment(attachment);
				if(res) {
					succeded.push(attachment);
				}
				else {
					failed.push(attachment);
				}
			}));
			this.saving.attachments = [];
			if(this.attachmentsToUpload.length == succeded.length) {
				return {
					success: true
				};
			}
			return {
				success: false,
				succeded: succeded,
				failed: failed
			}
		},
		async save() {
			if(this.validate()) {
				let upload = false;
				let uploadSuccess = false;
				if(this.fields.type == 'image') {
					if(this.edit) {
						if(this.fields.image.data != this.post.image.url) {
							upload = true;
							uploadSuccess = await this.uploadImage();
						}
					}
					else {
						upload = true;
						uploadSuccess = await this.uploadImage();
					}

				}
				else if(this.fields.type == 'video') {
					if(this.edit) {
						if(this.fields.video && !this.fields.video.id) {
							upload = true;
							uploadSuccess = await this.uploadVideo();
						}
					}
					else {
						upload = true;
						uploadSuccess = await this.uploadVideo();
					}

				}
				else if(this.fields.type == 'attachment' && this.attachmentsToUpload.length) {
					upload = true;
					const res = await this.uploadAttachments();
					if(res.success) {
						uploadSuccess = true;
					}
					else {
						console.log("FAILED UPLOADING ATTACHMENTS", res);
					}
				}

				if(!upload || (upload && uploadSuccess)) {
					this.saving.post = true;
					if(!this.edit) {
						// NEW POST
						await axios.post(this.saveUrl, this.finalModel)
							.then(response => {
								this.$emit('postAdded', response.data.data)
								this.saving.post = false;
								this.finish();
								this.$snackbar.success('Pomyślnie dodano post')
								return true;
							})
							.catch(error => {
								this.$snackbar.error({error})
								console.log("ERROR", error.response)
							})
					}
					else {
						// EDIT POST
						const res = await this.$store.dispatch('wall/editPost', {
							id: this.post.id,
							type: this.type,
							post: this.finalModel
						})
						if(res.success) {
							this.saving.post = false;
							this.$toast.success("Zapisano zmiany");
							this.finish();
							return true;
						}
						else {
							this.$snackbar.error(res.error)
						}
					}
					this.saving.post = false;

					return true;
				}
			}


		},
		announcementFinishTimeSelected(time) {
			if(time) {
				this.errors.announcement = null;
				this.fields.announcement.finishAt = time
			}
			else {
				this.fields.announcement.finishAt = null;
			}
		},
		finish() {
			this.validated = false;
			this.clear();
			this.closeDialog();
			this.$refs.form.resetValidation();
		},
		openChild(type) {
			this.child = true
			if(type == 'image') {
				this.$refs.attachImage.showDialog();
			}
			else if(type == 'video') {
				this.$refs.attachVideo.showDialog();
			}
			else if(type == 'poll') {
				this.$refs.attachPoll.setPoll(this.fields.poll);
			}
			else if(type == 'attachment') {
				this.$refs.attachAttachments.showDialog();
			}
			else if(type == 'kudos') {
				this.$refs.attachKudos.setKudos(this.fields.kudos);
				// this.$refs.attachKudos.showDialog();
			}
			else {
				return;
			}
		},
		clear() {
			this.validated = false;
			this.fields = {
				isCommentsDisabled: false,
				isPinned: false,
				type: 'post',
				content: {
					content: '',
					mentions: []
				},
				visibility: 'company',
				image: {},
				video: {},
				poll: {},
				announcement: {},
				attachments: [],
				kudos: {},
				imageToken: null,
				videoToken: null,
				attachmentTokens: []
			}
			this.contentKey++;
			this.inputKey++;
		},
		setType(type) {
			if(this.fields.type != type) {
				const t = this;
				this.fields.type = type;
				this.dialog = true;

				if(this.showSubject && this.$refs.subject) {
					this.$refs.subject.blur();
				}

				if(type == 'problem') {
					setTimeout(() => {
						if(t.$refs.subject) {
							t.$refs.subject.focus();
						}
					}, 200);
				}
				else if(type == 'announcement') {
					this.fields.announcement = {
						finishAt: null,
						pinned: false
					};
				}
				else if(type == 'attachment') {
					this.fields.attachments = [];
				}
				else if(type == 'kudos') {
					this.fields.kudos = {};
				}

				else {
					setTimeout(() => {
						if(t.$refs.text) {
							t.$refs.text.focus();
						}
					}, 200);
				}
				setTimeout(() => {
					t.$refs.form.resetValidation()
				}, 300)

			}


		},
		removeImage() {
			if(!this.edit) {
				this.setType('post');
			}
			this.fields.image = null;
		},
		removeVideo() {
			if(!this.edit) {
				this.setType('post');
			}
			this.fields.video = null;
		},
		removePoll() {
			if(!this.edit) {
				this.setType('post');
				this.$refs.attachPoll.clear();
			}
			this.fields.poll = null;

		},
		setImage(image) {
			this.setType('image');
			// Base64
			this.fields.image = {data: image};
			this.child = false;
			setTimeout(() => {
				this.validate();
			}, 300);
			this.validate();
			this.contentKey++;
		},
		setVideo(video) {
			this.setType('video');
			this.fields.video = video;
			this.child = false;
			setTimeout(() => {
				this.validate();
			}, 300);
			this.contentKey++;
		},
		setPoll(poll) {
			this.setType('poll');
			this.fields.poll = poll;
			this.child = false;
			this.contentKey++;
		},
		setKudos(kudos) {
			this.setType('kudos');
			this.fields.kudos = kudos;
			this.fields.content = {
				content: 'Gratulacje :@mention=' + kudos.user.id + '@:',
				mention_users: [
					kudos.user
				],
				mentions: [kudos.user.id]
			}
			this.inputKey++;
			this.child = false;
			this.contentKey++;
		},
		setVisibility(type) {
			this.fields.visibility = type;
		},
		getVisibility(name) {
			return this.selects.visibility.find(x => x.name == name)
		},
		addAttachments(files) {
			this.setType('attachment');
			let attachments = Array.from(files);
			attachments.forEach((file) => {
				if(!this.fields.attachments.find(x => x.name == file.name)) {
					this.fields.attachments.push(file);
				}
			});
		},
		showDialog(type = null) {

			if(type) {
				if(type == 'image') {
					this.$refs.attachImage.showDialog()
				}
				else if(type == 'video') {
					this.$refs.attachVideo.showDialog()
				}
				else if(type == 'poll') {
					this.$refs.attachPoll.showDialog()
				}
				else if(type == 'problem') {
					this.dialog = true;
					this.setType('problem');
				}
				else if(type == 'announcement') {
					this.dialog = true;
					this.setType('announcement');
				}
				else if(type == 'attachment') {
					this.$refs.attachAttachments.showDialog()
				}
			}
			else {
				if(this.groupId) {
					this.fields.visibility = 'group';
					this.fields.visibilitable_id = this.groupId;
				}
				this.dialog = true;
			}
			if(this.edit && this.post) {
				setTimeout(() => {
					this.setPostData();
				}, 3000)

			}
		},
		closeDialog() {
			// this.clear();
			if(!this.isSaving) {
				this.validated = false;
				this.dialog = false;
				this.clear();
				this.$emit('closed');
			}
			else {
				this.$snackbar.error('Zapisywanie w trakcie');
			}
		},
		onInput(input) {
			if(input) {
				this.errors.content = false;
			}
		},
		setPostData() {
			//
		}
	},
	created() {
		if(this.post && this.edit) {
			this.validated = false;
			this.fields = {
				isCommentsDisabled: this.post.is_comments_disabled,
				isPinned: this.post.is_pinned,
				type: this.type,
				content: {
					content: this.post.content,
					mention_users: this.post.mention_users,
				},
				visibility: this.post.visibilitable_type,
				visibilitable_id: this.post.visibilitable_id,
				image: this.post.image,
				video: this.post.video,
				poll: {},
				announcement: {},
				attachments: [],
				kudos: {},
				imageToken: null,
				videoToken: null,
				attachmentTokens: []
			}

			if(this.type == 'image') {
				this.fields.image.data = this.post.image.url
			}
			else if(this.type == 'poll') {
				this.fields.poll = {
					question: this.post.postable.question,
					answers: this.post.postable.poll_answers,
					allowCustom: this.post.postable.is_allowed_custom_answers,
					finishAt: this.post.ended_at
				}
			}
			else if(this.type == 'announcement') {
				this.fields.announcement = {
					pinned: this.post.is_pinned
				}
				if(this.post.ended_at) {
					this.fields.announcement.finishAt = this.$moment(this.post.ended_at).local();
				}
				// this.fields.announcement.finishAt = this.post.ended_at;
			}
			else if(this.type == 'problem') {
				this.fields.title = this.post.postable.title;
				this.fields.content.content = this.post.postable.description;
				// this.fields.mention_users = this.post.mention_users;
				this.fields.problem = this.post.postable;
			}
			else if(this.type == 'attachment') {
				this.fields.attachments = [];
				this.post.attachments.forEach((file) => {
					this.fields.attachments.push(file);
				});
			}
			else if(this.type == 'kudos') {
				this.fields.kudos = {
					typeId: this.post.postable.kudos_type_id,
					user: this.post.postable.for_user,
					content: this.post.postable.content,
					image: this.post.postable.image
				}
			}
			this.contentKey++;
		}
		else {
			if(this.groupId) {
				this.fields.visibility = 'group';
				this.fields.visibilitable_id = this.groupId
			}

			let content = '';
			if(this.shareTitle) {
				content = this.shareTitle;
			}
			if(this.shareUrl) {
				if(this.shareTitle) {
					content += '\n';
				}
				content += this.shareUrl;
			}

			this.fields.content = {
				content: content,
				mentions: []
			}

			this.contentKey++;

		}
	}
}
</script>

<style lang="scss" scoped>
	.has-error {
		border-color: red !important;
	}
	.content-wrap {
		position: relative;
		.video-placeholder {
			width: 100%;
			height: 300px;
			background: var(--v-accent-base);
			color: white;
			text-align: center;
			display: flex;
			align-items: center;
			justify-content: center;
			flex-direction: column;
		}
		.clear {
			position: absolute;
			top: 10px;
			right: 10px;
			z-index: 1;
		}
	}

	.custom-action {
		.icon-button:not(:hover) {
			color: $muted !important;
		}
	}
	.icon-button {
		min-width: auto !important;
		&.active {
			background: var(--v-accent-lighten1) !important;
			color: var(--v-accent-base) !important;

			.v-icon {
				color: var(--v-accent-base) !important;
			}
		}
	}

	.buttons {
		position: absolute;
		display: flex;
		align-items: center;
		top: 20px;
		right: 20px;
		z-index: 3;
	}

	.outline-grey {
		border: 1px solid solid grey !important;
	}
</style>
